import { formatMoney } from 'accounting'

import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Checkbox, ListItem, StatusBadge, Text,
} from '@domain-group/suit-theme'

import type { OrderReconciliationPayload } from '@hooks/useOrderReconciliation'

import { statusColors } from '@functions/status'

type OrderReconciliationListItemProps = {
  callbacks: {
    editItem: () => void,
  },
  item: OrderReconciliationPayload['orderReconciliationItems']['items'][0],
}

const OrderReconciliationListItem = (props: OrderReconciliationListItemProps) => {
  const {
    callbacks: {
      editItem,
    },
    item: {
      actualTotal,
      balanced,
      comments,
      expectedTotal,
      invoiceNumber,
      itemType,
      orderNumber,
      provider,
      purchaseOrder,
      status,
      title,
    },
  } = props

  const isProcessingFeeItem = itemType === 'processing-fees'

  return (
    // @ts-expect-error TS2339
    <ListItem.WithCheckbox
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        paddingX: 'large',
        paddingY: 'medium',
      }}
      checkbox={(
        <Checkbox
          checked
          fontSize="small"
          iconChecked={balanced ? faCheckCircle : faTimesCircle}
          color={balanced ? 'green' : 'red'}
          style={{ cursor: 'auto' }}
        />
      )}
      disableHover={isProcessingFeeItem}
      onClick={!isProcessingFeeItem ? () => editItem() : undefined}
      showAngleIcon={!isProcessingFeeItem}
    >
      <Box flexDirection="column">
        <Text fontSize="small">{title}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {orderNumber} from {provider}
        </Text>

        {(purchaseOrder || invoiceNumber) && (
          <Text color="lightGrey" fontSize="xsmall" marginTop="medium">
            {purchaseOrder && `PO #${purchaseOrder} `}
            {invoiceNumber && `INV #${invoiceNumber} `}
          </Text>
        )}

        {comments && (
          <Text color="lightGrey" fontSize="xsmall" marginTop="medium">
            {comments}
          </Text>
        )}

        <StatusBadge
          boxProps={{ marginTop: 'medium' }}
          ghost
          // @ts-expect-error TS7053
          color={statusColors[status.toLocaleLowerCase()]}
          text={status}
        />
      </Box>

      <Box alignItems="flex-end" flexDirection="column" marginLeft="auto">
        <Text color={balanced ? 'green' : 'red'} fontSize="small">
          {formatMoney(actualTotal)}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {/*
           // @ts-expect-error TS2769 */}
          {formatMoney(expectedTotal)}
        </Text>
      </Box>
      {/*
     // @ts-expect-error TS2339 */}
    </ListItem.WithCheckbox>
  )
}
export default OrderReconciliationListItem
